import { combineRules } from 'fela'; // eslint-disable-line behance/no-deprecated

import { ThemeProvider, connect, withTheme as _withTheme, FelaTheme } from 'react-fela'; // eslint-disable-line behance/no-deprecated

import applyStaticStyles from './applyStaticStyles';
import applyTheme from './applyTheme';
import createComponent from './createComponent';
import createComponentStyles from './createComponentStyles';
import createStyledComponent, { filterStyleProps } from './createStyledComponent';
import withRenderer from './withRenderer';
import { ariaAttributes, isValidElementProp, filterValidElementProps } from './isValidElementProp';
export * from './types';
export var withTheme = _withTheme;
export { createComponent, ariaAttributes, applyTheme, ThemeProvider, FelaTheme, connect, combineRules, createComponentStyles, withRenderer, applyStaticStyles, createStyledComponent, isValidElementProp, filterValidElementProps, filterStyleProps };